import { useCallback, useMemo } from "react";
import { useAuth } from "../context/AuthContext";
import { useSharedState } from "./useSharedState";

export default function useRoomToken(roomId: string) {
  const auth = useAuth();
  const [roomToken, setToken] = useSharedState<string | null>(
    roomId + ":room-token",
    null
  );
  const [error, setError] = useSharedState<string | null>(
    roomId + ":room-token-error",
    null
  );
  const fetchToken = useCallback(async () => {
    if (auth.isSignedIn) {
      const token = await auth.getIdToken();
      if (token) {
        try {
          const res = await fetch("/api/room-token", {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ roomId })
          });
          if (!res.ok) {
            throw Error("Failed to fetch room token!");
          }
          const data = (await res.json()) as { accessToken: string };
          setToken(data.accessToken);
          return data.accessToken;
        } catch (err) {
          console.error(err);
          setError((err as Error)?.message);
        }
      }
    }
    return null;
  }, []);
  return useMemo(() => ({ roomToken, error, fetchToken }), [
    roomToken,
    error,
    fetchToken
  ]);
}
